import { render, staticRenderFns } from "./Fair.vue?vue&type=template&id=5b8746a4&scoped=true"
import script from "./Fair.vue?vue&type=script&lang=js"
export * from "./Fair.vue?vue&type=script&lang=js"
import style0 from "./Fair.vue?vue&type=style&index=0&id=5b8746a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8746a4",
  null
  
)

export default component.exports